export default __webpack_public_path__ + "static/menu-gindakohighball-min2-391484804ec3c010ddead86a7e8d7f77.jpg";